import { Link, Outlet } from 'react-router-dom';
import { format } from 'date-fns-tz';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Livelo from 'assets/img/livelo-icon.svg';
import BBConsorcios from 'assets/img/bb-consorcio.svg';
import BBSeguros from 'assets/img/bb-seguros.svg';
import { BsPlusLg } from 'react-icons/bs';
import { BiMinus } from 'react-icons/bi';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'context/AuthContext';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import { getCatalogoExtrato, getLiveloPoints, getPlayerInfo, getResultadosByUser } from 'services/dashboard.service';
import Tippy from '@tippyjs/react';
import { RiArrowLeftSLine } from 'react-icons/ri';
import TabTitle from 'components/tab-title';
import './style.scss';
import { getNamedDates } from 'services/utils';
import { resolveComposicaoExtrato } from './extrato-premiacao-cards';
import {
  textoNivelJogandoJuntoNaoAtingido,
  textoOndeConferirPreRequisito,
  textoRequisitoNaoAtingido,
} from './aviso-pre-requisito';
import { loadExperiencePurchase } from 'services/experienceCataolog.service';

export default function Catalogo() {
  const { user, userInfo, realCycle } = useContext(AuthContext);
  const dates = getNamedDates();

  const [showMore, setShowMore] = useState<boolean>(false);
  const [showMoreGale, setShowMoreGale] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>();
  const [cultura, setCultura] = useState<any>();
  const [livelo, setLivelo] = useState<any>();
  const [optionsCycle, setOptionsCycle] = useState<any>([]);
  const [activeItem, setActiveItem] = useState('');
  const [activeItemObj, setActiveItemObj] = useState<any>({});
  const [experienceInfo, setExperienceInfo] = useState<boolean>(false);
  const [infoPlayer, setInfoPlayer] = useState<any>({});

  // Cards, letras e rótulo do Total do ciclo 1S2026 em diante; ciclos anteriores caem no
  // caminho legado logo abaixo, com os literais que sempre tiveram.
  const composicao = resolveComposicaoExtrato({
    dateStart: activeItemObj?.date_start,
    tipoDeAcordo: infoPlayer?.tipo_de_acordo,
  });

  // No 1S2026 a Premiação Coletiva sai de cena para quem tem acordo Predefinido. Ciclos
  // anteriores não têm essa regra, e `novaComposicao` false mantém o card para todos.
  const mostraPremiacaoColetiva = !composicao.novaComposicao || composicao.cards.includes('coletiva');

  useEffect(() => {
    if (!user) return;

    async function loadData() {
      const cycleTitle = realCycle?.find(item => item._id === activeItem)?.title;

      setLoading(true);
      if (user?._id && activeItem && cycleTitle) {
        const info = await getPlayerInfo(user._id, cycleTitle);
        setInfoPlayer(info);

        const res = await getLiveloPoints(activeItem);
        setLivelo(res[0]);
        const responseCatalogExperience = await loadExperiencePurchase(user?._id, cycleTitle);

        if (responseCatalogExperience) {
          setExperienceInfo(true);
        }

        if (activeItem === '64258cc0b9284a0aa19f80ba') {
          const data = await getCatalogoExtrato();
          const resp = await getResultadosByUser(user._id, activeItem);
          setData(data[0]);
          setCultura(resp[0]);
        }

        if (activeItem === '65bb010f3d7ea65950a3ebfe') {
          const resp = await getResultadosByUser(user._id, activeItem);
          setCultura(resp[0]);
        }
      }
      setLoading(false);
    }

    loadData();
  }, [user, activeItem, realCycle]);

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle
      .filter((item: any) => item.date_start >= dates.ciclo_1S2023 && item.date_start <= dates.ciclo_1S2026)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;
        return cycle;
      });

    setOptionsCycle(cycleOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle]);

  function handlePoint(point: number) {
    switch (point) {
      case 600:
        return '1.000';
      case 1200:
        return '2.000';
      case 2400:
        return '3.000';
      case 3600:
        return '4.000';
      default:
        return 0;
    }
  }

  function handlePointText(point: number) {
    if (activeItemObj?.date_start < dates.ciclo_2S2023) {
      switch (point) {
        case 600:
          return 'Etapa 3 apreciação: Bonificada';
        case 1200:
          return 'Etapa 4 apreciação: Bonificada';
        case 2400:
          return 'Etapa 5 apreciação: Bonificada';
        case 3600:
          return 'Etapa Selo: Indicada Selo Realização Destaque';
        default:
          return '';
      }
    } else {
      switch (point) {
        case 2000:
          return 'Nível 2 apreciação: Bonificada';
        case 7000:
          return 'Nível 3 apreciação: Bonificada';
        case 13000:
          return 'Nível Selo: Indicada Selo Realização Destaque';
        default:
          return '';
      }
    }
  }

  function handleCultura(behavior: string) {
    switch (behavior) {
      case 'colaboracao':
        return 'Colaboração';
      case 'foco':
        return 'Foco no Cliente';
      case 'inovacao':
        return 'Inovação';
      case 'resolutividade':
        return 'Protagonismo';
      case 'lideranca':
        return 'Liderança Integradora';
      default:
        return '';
    }
  }

  function handleTextGale(value: any) {
    if (activeItemObj?.date_start < dates.ciclo_2S2023) {
      switch (value) {
        case 2000:
          return {
            text: (
              <small className="text-sm font-thin">
                {' '}
                <b>pontos</b>
                {livelo?.bonus_galeria_reconhecimento > 0 && (
                  <span>
                    {' '}
                    adquiridos na <b>{'Faixa 1'}</b>
                  </span>
                )}
              </small>
            ),
            description: (
              <p className="font-thin">{'Você ficou entre os 10% mais bem colocados na pontuação geral atingindo a faixa 1.'}</p>
            ),
          };
        case 1000:
          return {
            text: (
              <small className="text-sm font-thin">
                {' '}
                <b>pontos</b>
                {livelo?.bonus_galeria_reconhecimento > 0 && (
                  <span>
                    {' '}
                    adquiridos na <b>{'Faixa 2'}</b>
                  </span>
                )}
              </small>
            ),
            description: (
              <p className="font-thin">{'Você ficou entre os 20% mais bem colocados na pontuação geral atingindo a faixa 2.'}</p>
            ),
          };
        case 500:
          return {
            text: (
              <small className="text-sm font-thin">
                {' '}
                <b>pontos</b>
                {livelo?.bonus_galeria_reconhecimento > 0 && (
                  <span>
                    {' '}
                    adquiridos na <b>{'Faixa 3'}</b>
                  </span>
                )}
              </small>
            ),
            description: (
              <p className="font-thin">{'Você ficou entre os 30% mais bem colocados na pontuação geral atingindo a faixa 3.'}</p>
            ),
          };
        default:
          return { text: '', description: '' };
      }
    } else {
      const { multiplicador, pontos_bonus } = value;
      switch (multiplicador) {
        case 3:
          return {
            text: (
              <small className="text-sm font-thin">
                {' '}
                <b>pontos Livelo</b>
                {livelo?.bonus_galeria_reconhecimento > 0 && (
                  <span>
                    {' '}
                    adquiridos na <b>{'Faixa 1'}</b>
                  </span>
                )}
              </small>
            ),
            description: <p className="font-thin">{'Alcançou o nível #UAU, recebe "Meus Pontos" multiplicados por 3 (três)'}</p>,
          };
        case 2:
          return {
            text: (
              <small className="text-sm font-thin">
                {' '}
                <b>pontos Livelo</b>
                {livelo?.bonus_galeria_reconhecimento > 0 && (
                  <span>
                    {' '}
                    adquiridos na <b>{'Faixa 2'}</b>
                  </span>
                )}
              </small>
            ),
            description: (
              <p className="font-thin">{'Alcançou o nível #MandouBem, recebe "Meus Pontos" multiplicados por 2 (dois)'}</p>
            ),
          };
        case 1.5:
          return {
            text: (
              <small className="text-sm font-thin">
                {' '}
                <b>pontos Livelo</b>
                {livelo?.bonus_galeria_reconhecimento > 0 && (
                  <span>
                    {' '}
                    adquiridos na <b>{'Faixa 3'}</b>
                  </span>
                )}
              </small>
            ),
            description: (
              <p className="font-thin">{'Alcançou o nível #Valeu, recebe "Meus Pontos" multiplicados por 1,5 (um e meio)'}</p>
            ),
          };
        case 0:
          return {
            text: (
              <small className="text-sm font-thin">
                {' '}
                <b>pontos Livelo</b>
              </small>
            ),
            description: '',
          };
        default:
          return { text: '', description: '' };
      }
    }
  }

  function getMyPoints() {
    if (activeItemObj?.date_start >= dates.ciclo_1S2024 && activeItemObj?.date_start < dates.ciclo_2S2024) {
      if (
        (!livelo?.nivel || livelo?.nivel === 'nenhum' || livelo?.nivel === 'iniciante') &&
        livelo?.grupo !== 'NAO AVALIAVEL' &&
        !livelo?.grupo?.includes('CONEXAO')
      ) {
        return (
          <small className="text-sm font-thin">Você não atingiu o nível Jogando Junto (IN 403-1 item 7.3.8.2.4.8.3.4)</small>
        );
      } else {
        return (
          <>
            <b>{formatNumber(livelo?.jogando_junto)}</b>
            <small className="text-sm font-thin">
              {' '}
              <b>pontos Livelo</b>
            </small>
          </>
        );
      }
    }

    if (activeItemObj?.date_start >= dates.ciclo_2S2024) {
      if (
        (!livelo?.nivel || livelo?.nivel === 'nenhum' || livelo?.nivel === 'iniciante') &&
        livelo?.grupo !== 'NAO AVALIAVEL' &&
        !livelo?.grupo?.includes('CONEXAO')
      ) {
        return <small className="text-sm font-thin">{textoNivelJogandoJuntoNaoAtingido(activeItemObj?.date_start)}</small>;
      } else {
        return (
          <>
            <p className="text-white block w-full text-sm">
              <span className="text-electric-blue">{livelo?.meus_pontos_sem_multiplicador}</span> Pontos Joga Junto{' '}
              <span className="text-electric-blue mx-2"> X </span> Nível de Reconhecimento{' '}
              <span className="text-electric-blue">= {livelo?.multiplicador_meus_pontos}</span>
            </p>
            <b>{formatNumber(livelo?.meus_pontos)}</b>
            <small className="text-sm font-thin">
              {' '}
              <b>pontos</b> adquiridos
            </small>
          </>
        );
      }
    }

    if (activeItemObj?.date_start < dates.ciclo_2S2023) {
      return (
        <>
          <b>{formatNumber(livelo?.meus_pontos)}</b>
          <small className="text-sm font-thin">
            {' '}
            <b>pontos</b> adquiridos
          </small>
        </>
      );
    }

    if (typeof livelo?.status_points === 'string' && livelo?.status_points === 'pre_requisito_nao_cumprido') {
      return (
        <>
          <p className="text-sm block mb-1 font-thin">
            Você não atingiu o cumprimento de pelo menos um dos requisitos elencados na IN 403-1 item 8.1.7.2.
          </p>
          <p className="text-sm block font-thin">
            Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB {'>'} Minha Visão {'>'} PDG{' '}
            {'>'} Joga Junto BB 2023/2 {'>'} Indicadores.
          </p>
        </>
      );
    }

    if (livelo?.grupo === 'SEM ATUAÇÃO MÍNIMA') {
      return (
        <small className="text-sm font-thin">
          Você não teve atuação mínima de 90 dias nos cargos/funções público-alvo do Joga Junto BB 2S2023 (IN 403-1 item
          8.1.7.2.1)
        </small>
      );
    }

    if (livelo?.grupo?.includes('CONEXAO') && activeItemObj?.date_start < dates.ciclo_1S2024) {
      return (
        <small className="text-sm font-thin">
          Você faz parte do público-alvo do Prêmio Conexão 2S2023, sua premiação no Joga Junto se limitará à concessão de selos no
          humanograma e selos digitais conquistados nas dinâmicas da Galeria do Reconhecimento, Destaque da Cultura ou Realização
          Destaque que recebeu o Selo (IN 403-1 item 8.1.3.4)
        </small>
      );
    }

    if (!livelo?.nivel || livelo?.nivel === 'nenhum' || livelo?.nivel === 'iniciante') {
      return <small className="text-sm font-thin">Você não atingiu o nível Jogando Junto (IN 403-1 item 7.1.7.10)</small>;
    }

    return (
      <>
        <b>{formatNumber(livelo?.meus_pontos)}</b>
        <small className="text-sm font-thin">
          {' '}
          <b>pontos</b> adquiridos
        </small>
      </>
    );
  }

  function formatNumber(num: number): string {
    if (!num) return '0';
    return num.toLocaleString('pt-BR');
  }

  function toltipText() {
    if (activeItemObj?.date_start >= dates.ciclo_2S2025) {
      return (
        <p>
          conforme IN 403-1 item <b>6.5.7.3.2</b> O total da premiação coletiva ao final do ciclo semestral se limitará a 80.000
          (oitenta mil) pontos, por funcionário.
        </p>
      );
    }

    if (activeItemObj?.date_start >= dates.ciclo_1S2024) {
      return (
        <div>
          <p className="mb-2">
            <b>Prêmio:</b> Pontos Livelo aos participantes de Realizações Destaques bonificadas pela apreciação nível 2 ou 3 ou o
            Selo, conforme IN 403-1, item 7.2.7.10, sendo:
          </p>
          <ul className="list-custom">
            <li>
              <b>Bonificadas pela apreciação nível 2</b>: Até limite 2.000 (dois mil) pontos livelo.
            </li>
            <li>
              <b>Bonificadas pela apreciação nível 3</b>: Até 7.000 (sete mil) pontos Livelo.
            </li>
            <li>
              <b>Reconhecidas com Selo</b>: Até 13.000 (treze mil) pontos Livelo.
            </li>
          </ul>
        </div>
      );
    }

    if (activeItemObj?.date_start < dates.ciclo_2S2023) {
      return (
        <p>
          Entenda como funciona o valor do prêmio Livelo nas etapas de apreciação: <br />
          <br />
          Etapa 3: 1.000 pontos Livelo
          <br />
          <br />
          Etapa 4: 2.000 pontos Livelo
          <br />
          <br />
          Etapa 5: 3.000 pontos Livelo
          <br />
          <br />
          Etapa Selo: 4.000 pontos Livelo
          <br />
          <br />
          <span>
            O Bônus se limita a um por fase para cada funcionário que participou de Realizações bonificadas com 600, 1.200, 2.400
            ou 3.600 pontos. Independentemente da quantidade de Realizações pontuadas naquela fase, o Bônus corresponderá à
            Realização que recebeu a maior pontuação.
          </span>
        </p>
      );
    }

    return (
      <p>
        O valor da premiação coletiva é determinado com base na participação em realizações bonificadas nos níveis de apreciação 2
        ou 3. <br />
        <br />
        Se você participou de uma realização bonificada no nível 2, receberá até 2.000 pontos Livelo.
        <br />
        <br />
        Se você participou de uma realização bonificada no nível 3, receberá até 7.000 pontos Livelo.
        <br />
        <br />
        Se foi reconhecido com o Selo Realização Destaque, receberá até 13.000 pontos Livelo.
        <br />
        <br />
        Se você participou de mais de uma realização bonificada em um mês, será considerada apenas a entrega de maior pontuação.
      </p>
    );
  }

  function toltipTextSecond() {
    if (activeItemObj?.date_start >= dates.ciclo_2S2024) {
      return <p>Pontos Joga Junto x nível de reconhecimento.</p>;
    }

    if (activeItemObj?.date_start >= dates.ciclo_1S2024) {
      return (
        <p>
          <b>Prêmio:</b> Pontos Livelo em quantidade equivalente à pontuação conquistada em “Meus Pontos” para todos os
          funcionários que finalizarem no <b>nível Jogando Junto.</b>
        </p>
      );
    }
    return <p>1 ponto JogaJunto equivale a 1 ponto Livelo.</p>;
  }

  function toltipJogandoJunto() {
    return (
      <>
        <p className="mb-2 block">
          <b>Prêmio:</b> Pontos Livelo conquistados em “Meus Pontos” para todos os funcionários que finalizarem no{' '}
          <b>níveis #UAU, #MandouBem e #Valeu ,</b> sendo:
        </p>
        <ul className="list-custom">
          <li>
            <b>nível #UAU</b>: “Meus Pontos” multiplicados por 3 (três) em Pontos Livelo.
          </li>
          <li>
            <b>nível #MandouBem</b>: “Meus Pontos” multiplicados por 2 (dois) em Pontos Livelo.
          </li>
          <li>
            <b>nível #Valeu</b>: “Meus Pontos” multiplicados por 1,5 (um e meio) em Pontos Livelo.
          </li>
        </ul>
      </>
    );
  }

  function toltipDestaque() {
    return (
      <p>
        <b>Prêmio</b>: 2 mil pontos Livelo aos <b>5% melhor Classificados do grupo</b> em cada Dimensão da Cultura (Colaboração;
        Inovação, Foco no Cliente, Protagonismo ou Liderança Integradora).
      </p>
    );
  }

  function getPointsGaleria(item: any) {
    const ponto = livelo.meus_pontos ? livelo.meus_pontos : 0;
    const pontos = item?.pontos_bonus ? item?.pontos_bonus : 0;
    if (typeof item === 'object') return formatNumber(ponto + pontos);
    return formatNumber(item);
  }

  function showItem() {
    return activeItemObj?.date_start >= dates.ciclo_2S2023;
  }

  function showItem2() {
    return activeItemObj?.date_start >= dates.ciclo_1S2024;
  }

  function expText2() {
    if (activeItemObj?.date_start >= dates.ciclo_2S2024) {
      if (
        (typeof livelo?.status_points === 'string' &&
          (livelo?.status_points === 'pre_requisito_nao_cumprido' || livelo?.status_points === 'impedido')) ||
        livelo?.grupo === 'NAO AVALIAVEL'
      ) {
        if (activeItemObj?.date_start >= dates.ciclo_2S2025) {
          return (
            <div>
              <p className="text-yellow text-bold text-lg -mt-10 mb-10" tabIndex={0}>
                {textoRequisitoNaoAtingido(activeItemObj?.date_start)}
                <br />
                {textoOndeConferirPreRequisito(activeItemObj?.title)}
              </p>
            </div>
          );
        }

        return activeItemObj?.date_start >= dates.ciclo_1S2025 ? (
          <div>
            <p className="text-yellow text-bold text-lg -mt-10 mb-10" tabIndex={0}>
              Você não atingiu o cumprimento de pelo menos um dos requisitos elencados na IN 403-1 item 6.4.8.2.3.
              <br />
              {`Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB > Minha Visão > Extrato de Premiação> Joga Junto BB 2025/1 > Indicadores.`}
            </p>
          </div>
        ) : (
          <div>
            <p className="text-yellow text-bold text-lg -mt-10 mb-10" tabIndex={0}>
              Você não atingiu o cumprimento de pelo menos um dos requisitos elencados na IN 403-1 item 7.3.8.
              <br />
              {`Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB > Minha Visão > Extrato de Premiação> Joga Junto BB 2024/2 > Indicadores.`}
            </p>
          </div>
        );
      } else if (typeof livelo?.grupo === 'string' && livelo?.grupo?.includes('CONEXAO')) {
        return (
          <div>
            <p className="text-yellow text-bold text-lg -mt-10 mb-10" tabIndex={0}>
              Você não é público alvo do Joga Junto para premiação em Pontos Livelo, por ser participante do Prêmio Conexão. IN
              403-1 7.3.3.2.
              <br />
            </p>
          </div>
        );
      } else {
        return (
          <div>
            {/* <p className="text-yellow text-bold text-lg -mt-10 mb-10">
              Os pontos livelo já foram creditados. <br />
              Na próxima semana, a Livelo vai trazer uma promoção especial exclusiva para os funcionários participantes do Joga
              Junto BB. <br />
              Aguarde!!👏👏
            </p> */}
          </div>
        );
      }
    }

    if (
      (typeof livelo?.status_points === 'string' && livelo?.status_points === 'pre_requisito_nao_cumprido') ||
      livelo?.grupo === 'NAO AVALIAVEL' ||
      livelo?.grupo?.includes('CONEXAO')
    ) {
      return (
        <div>
          <p className="text-yellow text-bold text-lg -mt-10 mb-10" tabIndex={0}>
            Você não atingiu o cumprimento de pelo menos um dos requisitos elencados na IN 403-1 item 7.2.7. <br />
            {`Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB > Minha Visão > PDG > Joga Junto BB 2024/1 > Indicadores.`}
          </p>
        </div>
      );
    } else {
      return (
        <div>
          <p className="text-yellow text-bold text-lg -mt-10 mb-10" tabIndex={0}>
            Os pontos livelo já foram creditados. <br />
            Na próxima semana, a Livelo vai trazer uma promoção especial exclusiva para os funcionários participantes do Joga
            Junto BB. <br />
            Aguarde!!👏👏
          </p>
        </div>
      );
    }
  }

  function expText() {
    if (activeItemObj?.date_start >= dates.ciclo_2S2024) {
      if (
        typeof livelo?.status_points === 'string' &&
        (livelo?.status_points === 'pre_requisito_nao_cumprido' || livelo?.status_points === 'impedido')
      ) {
        if (activeItemObj?.date_start >= dates.ciclo_2S2025) {
          return (
            <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
              <p className="text-sm block mb-1 font-thin">
                {textoRequisitoNaoAtingido(activeItemObj?.date_start)}
                <br />
                {textoOndeConferirPreRequisito(activeItemObj?.title)}
              </p>
            </div>
          );
        }

        return activeItemObj?.date_start >= dates.ciclo_1S2025 ? (
          <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
            <p className="text-sm block mb-1 font-thin">
              Você não atingiu o cumprimento de pelo menos um dos requisitos elencados na IN 403-1 item 6.4.8.2.3.
            </p>
            <p className="text-sm block font-thin">
              {`Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB > Minha Visão > Extrato de Premiação> Joga Junto BB 2025/1 > Indicadores.`}
            </p>
          </div>
        ) : (
          <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
            <p className="text-sm block mb-1 font-thin">
              Você não atingiu o cumprimento de pelo menos um dos requisitos elencados na IN 403-1 item 7.3.8.
            </p>
            <p className="text-sm block font-thin">
              {
                'Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB > Minha Visão > Extrato de Premiação> Joga Junto BB 2024/2 > Indicadores.'
              }
            </p>
          </div>
        );
      } else if (livelo?.grupo === 'NAO AVALIAVEL') {
        return (
          <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
            <p className="text-sm block font-thin">
              Você não cumpriu um dos pré-requisitos de participação do Programa Joga Junto BB 1S2024 descritos na IN 403-1 item
              7.2.
            </p>
          </div>
        );
      } else if (livelo?.grupo?.includes('CONEXAO')) {
        return (
          <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
            <p className="text-sm block font-thin">
              Você não é público alvo do Joga Junto para premiação em Pontos Livelo, por ser participante do Prêmio Conexão. IN
              403-1 7.3.3.2.
            </p>
          </div>
        );
      }
    }

    if (activeItemObj?.date_start >= dates.ciclo_1S2024) {
      if (typeof livelo?.status_points === 'string' && livelo?.status_points === 'pre_requisito_nao_cumprido') {
        return (
          <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
            <p className="text-sm block mb-1 font-thin">
              Você não atingiu o cumprimento de pelo menos um dos requisitos elencados na IN 403-1 item 7.2.7.
            </p>
            <p className="text-sm block font-thin">
              Para verificar qual o pré-requisito não foi cumprido, você pode acessar Plataforma BB {'>'} Minha Visão {'>'} PDG
              {'>'} Joga Junto BB 2024/1 {'>'} Indicadores.
            </p>
          </div>
        );
      } else if (livelo?.grupo === 'NAO AVALIAVEL') {
        return (
          <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
            <p className="text-sm block font-thin">
              Você não cumpriu um dos pré-requisitos de participação do Programa Joga Junto BB 1S2024 descritos na IN 403-1 item
              7.2.
            </p>
          </div>
        );
      } else if (livelo?.grupo?.includes('CONEXAO')) {
        return (
          <div className="block border-t border-[#072E4A] pt-6 mt-5" tabIndex={0}>
            <p className="text-sm block font-thin">
              Você faz parte do público-alvo do Prêmio Conexão 1S2024, sua premiação no Joga Junto se limitará à concessão de
              selos no humanograma e selos digitais conquistados nas dinâmicas da Galeria do Reconhecimento, Destaque da Cultura
              ou Realização Destaque que recebeu o Selo (IN 403-1 item 7.2.3.4).
            </p>
          </div>
        );
      }
      return null;
    }
    return null;
  }

  return (
    <>
      <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
        <div className="mb-3 lg:mb-10 lg:flex justify-between">
          <div className="flex flex-ro items-center space-x-3 lg:space-x-1">
            <div>
              <Link to="../" tabIndex={-1}>
                <button className="rounded-full bg-purple flex justify-center items-center p-1" tabIndex={0} aria-label="Voltar ">
                  <RiArrowLeftSLine size={28} className="text-white" />
                </button>
              </Link>
            </div>
            <h1 className="text-lg lg:text-3xl py-1 px-6 rounded-full" tabIndex={0}>
              {' '}
              {activeItemObj?.date_start <= dates.ciclo_1S2025 ? 'Pontos Livelo' : 'Extrato de Premiação'}{' '}
            </h1>
          </div>
          {!user?.extra.rede && activeItemObj?.date_start < dates.ciclo_2S2023 && (
            <div className="flex justify-center lg:block">
              <a
                href="https://www.livelo.com.br/jogajuntobb"
                target="_blank"
                rel="noopener noreferrer"
                download={'rede-joga-junto-bb.png'}
                className="bg-purple text-white hover:text-white active:text-white focus:text-white hover:ring hover:ring-white rounded-md shadow-xl font-bold px-6 py-3 uppercase inline-block no-underline hover:no-underline active:no-underline focus:no-underline"
              >
                <span className="p-1 leading-tight">ACESSAR CATÁLOGO LIVELO</span>
              </a>
            </div>
          )}
        </div>

        {activeItemObj?.date_start < dates.ciclo_2S2023 ? (
          <div className="lg:flex border-electric-blue border-2 rounded-2xl bg-oxford-blue py-5 px-7">
            <div
              className={`${user?.extra.rede ? '' : 'w-full lg:w-[40%] border-electric-blue lg:border-r-2 -my-5 py-5 pr-0 lg:pr-[70px] pl-3'}`}
              tabIndex={0}
            >
              <p className="text-lg" tabIndex={0}>
                {user?.extra.rede
                  ? 'Aguarde o crédito dos pontos ao final do Ciclo 1S2024.'
                  : 'Acesse o catálogo de experiências clicando no botão "Acessar catálogo Livelo" para escolher seu prêmio e obter descontos exclusivos! Não se esqueça de utilizar o cupom JOGAJUNTOBB ou JOGAJUNTO20.'}
              </p>
            </div>
            {!user?.extra.rede && (
              <div className="flex px-2 w-full lg:w-[60%] mt-5 lg:mt-0">
                <div className="w-[20%] pl-10">
                  <p className="text-yellow text-lg pt-3" tabIndex={0}>
                    Apoio:{' '}
                  </p>
                </div>
                <div className="flex flex-col lg:flex-row items-center justify-between w-[80%] lg:pr-5">
                  <img src={BBSeguros} alt="BBSeguros" />
                  <img src={Livelo} alt="Livelo" />
                  <img src={BBConsorcios} alt="BBConsorcios" />
                </div>
              </div>
            )}
          </div>
        ) : (
          <div></div>
        )}

        {activeItemObj?.date_start >= dates.ciclo_1S2026 ? (
          <div className="lg:flex border-electric-blue border-2 rounded-2xl bg-oxford-blue py-5 px-7">
            <div className={`'w-full -my-5 py-5 pr-0 lg:pr-[70px] pl-3'}`}>
              <p className="text-lg text-yellow">
                Caro(a) participante, a premiação ainda está em apuração. O extrato pessoal foi disponibilizado de forma prévia e
                não é garantia de premiação. O crédito da premiação está condicionado a verificação de impedimentos, conforme IN
                403-1, item 1.6.
              </p>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {!user?.extra.rede && (
          <div className="mt-10">
            <TabTitle
              options={optionsCycle}
              title={<p> Extrato de Premiação {activeItemObj?.date_start <= dates.ciclo_1S2025 ? 'Pontos Livelo' : ''} </p>}
              onCallBack={e => {
                setActiveItem(e.value);
                setActiveItemObj(e);
              }}
            />
          </div>
        )}

        {!loading && activeItemObj?.date_start >= dates.ciclo_1S2024 && <div>{expText2()}</div>}

        {loading && (
          <div className="grid grid-cols-1 gap-3">
            <ArticlePlaceholder />
            <ArticlePlaceholder />
            <ArticlePlaceholder />
          </div>
        )}

        {!loading && !user?.extra.rede && (
          <div className="space-y-2">
            <div className={`flex ${activeItemObj?.date_start >= dates.ciclo_1S2024 ? 'flex-col-reverse' : 'flex-col'}`}>
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 mt-2">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2 flex items-center space-x-2" tabIndex={0}>
                      <p>
                        {activeItemObj?.date_start >= dates.ciclo_1S2024 && activeItemObj?.date_start < dates.ciclo_2S2024 ? (
                          <>
                            Premiação Jogando Junto <span>(B)</span>
                          </>
                        ) : activeItemObj?.date_start >= dates.ciclo_2S2024 ? (
                          <>
                            Premiação Pontos Jogando Junto{' '}
                            {/* -
                            <span className="text-white">
                              Pontos Joga Junto <span className="text-electric-blue">x</span> nível de reconhecimento
                            </span>{' '} */}
                            <span>({composicao.letras.jogandoJunto ?? 'A'})</span>
                          </>
                        ) : (
                          <>Pontos JogaJuntoBB (Meus pontos)</>
                        )}
                      </p>{' '}
                      <Tippy arrow={true} className="" allowHTML={true} content={toltipTextSecond()}>
                        <div className="text-white">
                          <AiOutlineInfoCircle />
                        </div>
                      </Tippy>
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      {getMyPoints()}
                    </div>
                  </div>
                </div>
              </div>

              {(activeItemObj?.date_start < dates.ciclo_2S2023 || livelo?.bonus_galeria_reconhecimento?.pontos_bonus >= 0) && (
                <div className="bg-maastricht-blue-3 rounded-2xl p-8 mt-2">
                  <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                    <div>
                      <div className="text-yellow mb-2 flex items-center space-x-2" tabIndex={0}>
                        {showItem() && activeItemObj?.date_start < dates.ciclo_1S2024 ? (
                          <>
                            Bônus Galeria de Reconhecimento <span>(A)</span>
                          </>
                        ) : activeItemObj?.date_start >= dates.ciclo_1S2024 ? (
                          <>
                            Premiação Galeria do Reconhecimento <span>(A)</span>
                          </>
                        ) : (
                          <>Bônus Galeria de Reconhecimento</>
                        )}
                        {activeItemObj?.date_start >= dates.ciclo_1S2024 && (
                          <Tippy arrow={true} className="" allowHTML={true} content={toltipJogandoJunto()}>
                            <div className="text-white">
                              <AiOutlineInfoCircle />
                            </div>
                          </Tippy>
                        )}
                      </div>
                      <div className="text-2xl" tabIndex={0}>
                        <b>{getPointsGaleria(livelo?.bonus_galeria_reconhecimento)}</b>{' '}
                        {handleTextGale(livelo?.bonus_galeria_reconhecimento).text}
                      </div>
                    </div>
                    {(livelo?.bonus_galeria_reconhecimento > 0 || livelo?.bonus_galeria_reconhecimento?.pontos_bonus > 0) && (
                      <button
                        className="mt-4 flex items-center text-grey-light justify-center lg:justify-start"
                        onClick={() => setShowMoreGale(!showMoreGale)}
                      >
                        {showMoreGale ? (
                          <>
                            <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                            <span className="uppercase">Ver menos</span>
                          </>
                        ) : (
                          <>
                            <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                            <span className="uppercase">Ver mais</span>
                          </>
                        )}
                      </button>
                    )}
                  </div>
                  {showMoreGale && (
                    <div className="lg:flex justify-between border-t border-[#072E4A] pt-6 mt-5">
                      <div className="flex flex-col" tabIndex={0}>
                        {handleTextGale(livelo?.bonus_galeria_reconhecimento).description}
                      </div>
                      <div className="flex items-center">
                        <p className="text-electric-blue" tabIndex={0}>
                          + {getPointsGaleria(livelo?.bonus_galeria_reconhecimento)} pts Livelo
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {activeItemObj?.date_start < dates.ciclo_2S2023 && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2" tabIndex={0}>
                      Bônus Destaques da Cultura
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      <b>{formatNumber(livelo?.bonus_destaques_cultura)}</b>{' '}
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos</b> adquiridos{' '}
                        {!!cultura?.behavior && livelo?.bonus_destaques_cultura > 0 && (
                          <span>
                            pelo Selo <b>{handleCultura(cultura?.behavior)}</b>
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeItemObj?.date_start < dates.ciclo_2S2023 && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2 flex items-center space-x-2" tabIndex={0}>
                      <p>Bônus Realização Destaque</p>
                      <Tippy arrow={true} className="" allowHTML={true} content={toltipText()}>
                        <div className="text-white">
                          <AiOutlineInfoCircle />
                        </div>
                      </Tippy>
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      <b>{formatNumber(livelo?.total_realizacoes)}</b>{' '}
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos Livelo</b> adquiridos em <b>bonificações</b> por fases
                      </small>
                    </div>
                  </div>
                  {!!data && (
                    <button
                      className="mt-4 flex items-center text-grey-light justify-center lg:justify-start"
                      onClick={() => setShowMore(!showMore)}
                    >
                      {showMore ? (
                        <>
                          <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                          <span className="uppercase">Ver menos</span>
                        </>
                      ) : (
                        <>
                          <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                          <span className="uppercase">Ver mais</span>
                        </>
                      )}
                    </button>
                  )}
                </div>
                {showMore && (
                  <>
                    {data?.achiviment?.map((item: any) => (
                      <div key={item._id} className="lg:flex justify-between border-t border-[#072E4A] pt-6 mt-5">
                        <div className="flex flex-col">
                          <b className="text-yellow mb-4" tabIndex={0}>
                            {item.faseTitle}
                          </b>
                          <span className="text-police-blue text-xs font-light leading-none mb-2" tabIndex={0}>
                            {`Do dia ${format(item.task.start, 'dd/MM/yy')} ao ${format(item.task.end, 'dd/MM/yy')}`}
                          </span>
                          <p className="mb-4" tabIndex={0}>
                            {handlePointText(item.totalMissao)}
                          </p>
                          <p className="font-thin" tabIndex={0}>
                            Nome da Realização: {item.task.title}
                          </p>
                        </div>
                        <div className="flex items-center">
                          <p className="text-electric-blue" tabIndex={0}>
                            + {handlePoint(item.totalMissao)} pts Livelo
                          </p>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}

            {activeItemObj?.date_start >= dates.ciclo_2S2024 && infoPlayer?.tipo_de_acordo === 'HIBRIDO' && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2 flex space-x-1 items-center" tabIndex={0}>
                      <span>Premiação Pontos Realização Destaque</span>
                      {/* <span> - </span> */}{' '}
                      {/* <span className="text-white">
                        Pontos Realização Destaque <span className="text-electric-blue">x</span> Multiplicador por GFM
                      </span> */}
                      <span> ({composicao.letras.realizacaoDestaque ?? 'B'})</span>
                      <span>
                        {' '}
                        <Tippy
                          arrow={true}
                          className=""
                          allowHTML={true}
                          content={'Pontos Realização Destaque x Multiplicador por GFM.'}
                        >
                          <div className="text-white">
                            <AiOutlineInfoCircle />
                          </div>
                        </Tippy>
                      </span>
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      <p className="text-white block w-full text-sm">
                        <span className="text-electric-blue">{livelo?.meus_pontos_task_sem_multiplicador}</span> Pontos Realização
                        Destaque <span className="text-electric-blue mx-2"> X </span>Multiplicador GFM{' '}
                        <span className="text-electric-blue">= {livelo?.gfm_multiplicador | 0}</span>
                      </p>
                      <b>{formatNumber(livelo?.meus_pontos_task)}</b>
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos</b> adquiridos
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {composicao.cards.includes('conversaoFaixa') && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2 flex space-x-1 items-center" tabIndex={0}>
                      <span>Conversão da Faixa de Premiação em Espécie</span>
                      <span> ({composicao.letras.conversaoFaixa})</span>
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      <b>{formatNumber(livelo?.pontos_faixa)}</b>
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos</b> adquiridos
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeItemObj?.date_start >= dates.ciclo_2S2023 && activeItemObj?.date_start < dates.ciclo_2S2024 && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2 flex items-center space-x-2" tabIndex={0}>
                      <p>
                        Premiação Coletiva{' '}
                        {showItem() && activeItemObj?.date_start < dates.ciclo_1S2024 ? (
                          <span>(B)</span>
                        ) : activeItemObj?.date_start >= dates.ciclo_1S2024 ? (
                          <span>(C)</span>
                        ) : (
                          <span></span>
                        )}
                      </p>
                      <Tippy arrow={true} className="" allowHTML={true} content={toltipText()}>
                        <div className="text-white">
                          <AiOutlineInfoCircle />
                        </div>
                      </Tippy>
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      <b>{formatNumber(livelo?.premiacao_coletiva?.teto_pontos)}</b>{' '}
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos Livelo</b> adquiridos em <b>bonificações</b> por fases
                      </small>
                    </div>
                  </div>
                  {livelo?.premiacao_coletiva?.detalhes?.length > 0 && (
                    <button
                      className="mt-4 flex items-center text-grey-light justify-center lg:justify-start"
                      onClick={() => setShowMore(!showMore)}
                    >
                      {showMore ? (
                        <>
                          <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                          <span className="uppercase">Ver menos</span>
                        </>
                      ) : (
                        <>
                          <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                          <span className="uppercase">Ver mais</span>
                        </>
                      )}
                    </button>
                  )}
                </div>
                {showMore && livelo?.premiacao_coletiva?.detalhes?.length && (
                  <>
                    {livelo?.premiacao_coletiva?.detalhes?.map((item: any) => (
                      <div key={item.realizacao_id} className="lg:flex justify-between border-t border-[#072E4A] pt-6 mt-5">
                        <div className="flex flex-col">
                          <b className="text-yellow mb-4" tabIndex={0}>
                            {item.fase}
                          </b>
                          <p className="mb-4" tabIndex={0}>
                            {handlePointText(item?.premiacao_coletiva)}
                          </p>
                          <p className="font-thin" tabIndex={0}>
                            Nome da Realização: {item?.realizacao_titulo}
                          </p>
                        </div>
                        <div className="flex items-center">
                          <p className="text-electric-blue" tabIndex={0}>
                            + {formatNumber(item?.premiacao_coletiva)} pts Livelo
                          </p>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}

            {activeItemObj?.date_start >= dates.ciclo_1S2024 && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2 flex items-center space-x-2" tabIndex={0}>
                      {activeItemObj?.date_start >= dates.ciclo_2S2024 ? (
                        <p>
                          Premiação Destaques da Cultura <span> ({composicao.letras.cultura ?? 'C'})</span>
                        </p>
                      ) : (
                        <p>Premiação Destaques da Cultura BB {showItem2() && <span> (D)</span>}</p>
                      )}
                      {activeItemObj?.date_start >= dates.ciclo_1S2024 && (
                        <Tippy arrow={true} className="" allowHTML={true} content={toltipDestaque()}>
                          <div className="text-white">
                            <AiOutlineInfoCircle />
                          </div>
                        </Tippy>
                      )}
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      <b>{formatNumber(livelo?.bonus_destaques_cultura)}</b>{' '}
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos {activeItemObj?.date_start <= dates.ciclo_1S2025 ? 'Livelo' : ''}</b>
                        {!!cultura?.behavior && livelo?.bonus_destaques_cultura > 0 && (
                          <>
                            {' '}
                            <span>
                              por ter recebido um Destaque da Cultura com o Selo <b>{handleCultura(cultura?.behavior)}</b>
                            </span>
                          </>
                        )}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeItemObj?.date_start >= dates.ciclo_2S2025 && mostraPremiacaoColetiva && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between ">
                  <div>
                    <div className="text-yellow mb-2 flex items-center space-x-2" tabIndex={0}>
                      <p>
                        Premiação Coletiva <span>({composicao.letras.coletiva ?? 'D'})</span>
                      </p>
                      {livelo?.premiacao_coletiva?.passou_teto && (
                        <Tippy arrow={true} className="" allowHTML={true} content={toltipText()}>
                          <div className="text-white">
                            <AiOutlineInfoCircle />
                          </div>
                        </Tippy>
                      )}
                    </div>
                    <div className="text-2xl" tabIndex={0}>
                      <b>{formatNumber(livelo?.premiacao_coletiva?.teto_pontos)}</b>{' '}
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos</b> adquiridos em <b>bonificações</b> por fases
                      </small>
                    </div>
                  </div>
                  {livelo?.premiacao_coletiva?.detalhes?.length > 0 && (
                    <button
                      className="mt-4 flex items-center text-grey-light justify-center lg:justify-start"
                      onClick={() => setShowMore(!showMore)}
                    >
                      {showMore ? (
                        <>
                          <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                          <span className="uppercase">Ver menos</span>
                        </>
                      ) : (
                        <>
                          <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                          <span className="uppercase">Ver mais</span>
                        </>
                      )}
                    </button>
                  )}
                </div>
                {showMore && livelo?.premiacao_coletiva?.detalhes?.length && (
                  <>
                    {livelo?.premiacao_coletiva?.detalhes?.map((item: any) => (
                      <div key={item.realizacao_id} className="lg:flex justify-between border-t border-[#072E4A] pt-6 mt-5">
                        <div className="flex flex-col">
                          <b className="text-yellow mb-4" tabIndex={0}>
                            {item.fase}
                          </b>
                          <p className="mb-4" tabIndex={0}>
                            {handlePointText(item?.premiacao_coletiva)}
                          </p>
                          <p className="font-thin" tabIndex={0}>
                            Nome da Realização: {item?.realizacao_titulo}
                          </p>
                        </div>
                        <div className="flex items-center">
                          <p className="text-electric-blue" tabIndex={0}>
                            + {formatNumber(item?.premiacao_coletiva)} pontos
                          </p>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}

            {experienceInfo && activeItemObj?.date_start >= dates.ciclo_1S2025 && (
              <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between">
                  <div>
                    <h3 className="text-yellow mb-2" tabIndex={0}>
                      Catálogo de experiências
                    </h3>
                    <div className="text-2xl" tabIndex={0}>
                      - <b>{formatNumber(livelo?.pontos_usados)}</b>{' '}
                      <small className="text-sm font-thin">
                        {' '}
                        <b>pontos {activeItemObj?.date_start <= dates.ciclo_1S2025 ? 'Livelo' : ''}</b>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="bg-maastricht-blue-3 rounded-2xl p-8 ">
              <div className="flex flex-col lg:flex-row lg:items-center justify-between">
                <div>
                  <div className="text-yellow mb-2" tabIndex={0}>
                    Total de Pontos {activeItemObj?.date_start <= dates.ciclo_1S2025 ? 'Livelo' : ''} a creditar{' '}
                    {composicao.novaComposicao ? (
                      <span>{composicao.rotuloTotal}</span>
                    ) : showItem() && activeItemObj?.date_start < dates.ciclo_2S2025 ? (
                      <span>(A + B{activeItemObj?.date_start >= dates.ciclo_2S2024 ? ' + C ' : showItem2() && ' + C + D'})</span>
                    ) : (
                      <span>(A + B + C + D)</span>
                    )}
                  </div>
                  <div className="text-2xl" tabIndex={0}>
                    <b>{formatNumber(livelo?.total_pontos_livelo)}</b>{' '}
                    <small className="text-sm font-thin">
                      {' '}
                      <b>pontos {activeItemObj?.date_start <= dates.ciclo_1S2025 ? 'Livelo' : ''}</b>
                    </small>
                  </div>
                </div>
              </div>
              {expText()}
            </div>
          </div>
        )}
      </div>
      <Outlet />
    </>
  );
}
